import React from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import styles from "./side-nav.module.css";

export const SideNav = ({ categories, slug = undefined }) => {
  const router = useRouter();
  const slugs = router.query.slug || slug || [];

  const topCategory = categories?.find(
    (category) => category.attributes.slug === slugs[0]
  );

  const childrenCategories = topCategory?.attributes.children?.data.sort(
    (a, b) => {
      return a.attributes.order - b.attributes.order;
    }
  );

  return (
    <aside className={styles.sideNav}>
      <ul className={`flex flex-col relative`}>
        <li className={`border-b pb-5`}>
          <span className={`flex items-center min-h-[40px]`}>
            <h2
              className={`font-display font-bold text-[24px] uppercase leading-none`}
            >
              {topCategory?.attributes.name}
            </h2>
          </span>
        </li>
        {childrenCategories?.map((category, key) => {
          return (
            <li
              className={` ${
                category.attributes.featured
                  ? "text-[24px] border-b py-5 featured"
                  : "text-[18px] mt-5"
              }`}
              key={key}
            >
              <div
                className={
                  category.attributes.slug === slugs[1] ? styles.active : null
                }
              >
                <Link
                  href={`/category/${slugs[0]}/${category.attributes.slug}`}
                >
                  <a className={`hover:underline font-display`}>
                    {category.attributes.name}
                  </a>
                </Link>
              </div>
            </li>
          );
        })}
      </ul>
    </aside>
  );
};
